import React from "react"
export function CheckBoxOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M16 2a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h12zm.462 1H3.538a.539.539 0 00-.53.442L3 3.538v12.924c0 .264.19.484.442.53l.096.008h12.924c.264 0 .484-.19.53-.442l.008-.096V3.538a.539.539 0 00-.442-.53L16.462 3z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__check-box---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
